import React, { Component } from "react";
import styles from "./style.module.scss";
import { Button, Card, Dropdown, Icon, Menu, Modal, Row, Col, Spin, Table, Typography } from "antd";
import CONST from "../../utilities/constant";
import { observable, toJS } from "mobx";
import { MUTATE, QUERY } from "../../utilities/network";
import { observer } from "mobx-react";
import DashboardOverView from "../../components/dashboardOverView";
import DashboardJourneyLevelChart from "../../components/dashboardJourneyLevelChart";
import DashboardEffectsChart from "../../components/dashboardEffectsChart";
import DashboardTopBehaviorList from "../../components/dashboardTopBehaviorList";
import { RouteComponentProps } from "react-router";
import { StatisticsType } from "../advancedDashboard";
import queryString from "query-string";
import dayjs from "dayjs";
import {
  DELETE_MEMBER,
  GroupMemberType,
  RE_INVITE_MEMBER,
  UPDATE_MEMBER_SHIP,
} from "../memberList";
import DashboardTrendChart from "../../components/dashboardTrendChart";
import Membership from "../../store/membership";
import DashboardPracticedAreaChart from "../../components/dashboardPracticedAreaChart";
import DashboardHabitIndexTrend from "../../components/dashboardHabitIndexTrend";
import DashboardTrustNpsTrend from "../../components/dashboardTrustNpsTrend";
type StatusEnum = "Active" | "Not activated" | "Deactivated";

@observer
export default class GroupDetail extends Component<RouteComponentProps<{}>> {
  @observable groupDetailData: GroupDetailType | undefined;
  today = dayjs(new Date());
  groupId = 0;
  groupName = "";

  filteredGroupIds: Array<number> = [];
  filteredStatus: Array<StatusEnum> = [];

  get userStatusFilters() {
    return [
      { text: "Active", value: "Active" },
      { text: "Not activated", value: "Not activated" },
      { text: "Deactivated", value: "Deactivated" },
    ];
  }

  get active30DaysFilters() {
    return [
      { text: "Active", value: "Active" },
      { text: "Passive", value: "Passive" },
    ];
  }
  memberListColumns: Array<any> = [
    {
      title: "No.",
      dataIndex: "key",
      key: "key",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 100,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      filters: this.userStatusFilters,
      onFilter: (status: StatusEnum, member: GroupMemberType) => {
        if (status === "Deactivated") {
          return member.membership.valid_days === 0;
        } else if (status === "Not activated") {
          return member.status === "Inactivated";
        }
        return member.membership.valid_days !== 0 && member.status === "Activated";
      },
      render: (status: "Inactivated" | "Activated", member: GroupMemberType) => {
        if (member.membership.valid_days === 0) {
          return <Typography.Text type="warning">Deactivated</Typography.Text>;
        }
        if (status === "Inactivated") {
          return <Typography.Text type="danger">Not activated</Typography.Text>;
        }
        return <Typography.Text style={{ color: "#52c41a" }}>Active</Typography.Text>;
      },
    },
    {
      title: "Active last 30 days",
      dataIndex: "active_in_30_days",
      key: "active_in_30_days",
      width: 100,
      align: "center",
      filters: this.active30DaysFilters,
      onFilter: (status: "Active" | "Passive", member: GroupMemberType) =>
        member.active_in_30_days === (status === "Active"),
      render: (active_in_30_days: boolean) => {
        const backgroundColor = active_in_30_days ? "#52c41a" : "#f5222d";
        return (
          <div className={styles.active_30_days}>
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: 10,
                backgroundColor,
              }}
            />
          </div>
        );
      },
    },
  ];

  constructor(props: any) {
    super(props);

    try {
      const params = queryString.parse(decodeURI(this.props.location.search), {
        parseNumbers: true,
      }) as { id: number; name: string };

      this.groupId = params.id;
      this.groupName = params.name;
    } catch (e) {
      this.props.history.goBack();
    }
  }

  async componentDidMount() {
    if (this.groupId && this.groupName) {
      await this._fetchGroupData();
    } else {
      this.props.history.goBack();
    }
  }

  render() {
    if (!this.groupDetailData) {
      return (
        <div className={styles.vacant_container}>
          <Spin size="large" />
        </div>
      );
    }

    const { statistics, groupMembers } = this.groupDetailData;

    const {
      feed_forward_top_satisfied,
      feed_forward_top_requested,
      total_feed_forwards,
      practiced_loops,
      effect_survey,
      journey_sessions,
      weekly_trend,
      practiced_areas,
      feed_forward_quarterly_stats,
    } = statistics;
    // @ts-ignore
    const loopIds = [...new Set(practiced_loops.map((e) => e.loop_id))];
    const uniquePracticedLoops = loopIds.map(
      (loop_id) => practiced_loops.find((e) => e.loop_id === loop_id) as any,
    );

    return (
      <div className={styles.container}>
        <article>Training statistics for {this.groupName}</article>

        <DashboardOverView statistics={statistics} />

        <Row gutter={16} className={styles.row_margin_top}>
          <Col span={12}>
            <DashboardJourneyLevelChart journey_sessions={journey_sessions} />
          </Col>
          <DashboardEffectsChart effect_survey={effect_survey} />
        </Row>

        {weekly_trend.length > 0 && (
          <div className={styles.row_margin_top}>
            <DashboardTrendChart weekly_trend={weekly_trend} />
          </div>
        )}

        {feed_forward_quarterly_stats.length > 0 && (
          <div className={styles.row_margin_top}>
            <DashboardHabitIndexTrend feed_forward_quarterly_stats={feed_forward_quarterly_stats} />
          </div>
        )}
        {feed_forward_quarterly_stats.length > 0 && (
          <div className={styles.row_margin_top}>
            <DashboardTrustNpsTrend feed_forward_quarterly_stats={feed_forward_quarterly_stats} />
          </div>
        )}

        <div className={styles.row_margin_top}>
          <DashboardPracticedAreaChart
            practicedAreas={practiced_areas}
            practicedLoops={practiced_loops}
          />
        </div>

        <Row gutter={CONST.CONTENT_MARGIN} className={styles.row_margin_top}>
          <DashboardTopBehaviorList
            title="Top 5 habits"
            tips="The top 5 behaviors colleagues think their leaders do frequently enough. This is summarized from the Leadership Habit Profile, answered by the respective team member."
            loops={total_feed_forwards > 2 ? feed_forward_top_satisfied : []}
          />
          <DashboardTopBehaviorList
            title="Top 5 requested behaviors"
            tips="The top 5 behaviors colleagues wants leaders to do more of, more frequently. This is summarized from the Leadership Habit Profile, answered by the respective team member."
            loops={total_feed_forwards > 2 ? feed_forward_top_requested : []}
          />
          <DashboardTopBehaviorList
            title="Top practiced behaviors"
            tips="Top completed training sessions."
            loops={uniquePracticedLoops}
          />
        </Row>

        {this._renderMemberList(toJS(groupMembers))}
      </div>
    );
  }

  _renderMemberList = (members: Array<GroupMemberType>) => {
    const inviteBtn = this.groupId !== CONST.B2C_GROUP_ID && (
      <Button type="primary" icon="plus" onClick={this._goToInviteMemberPage}>
        Members
      </Button>
    );
    const columns =
      this.groupId === CONST.B2C_GROUP_ID
        ? this.memberListColumns
        : [
            ...this.memberListColumns,
            {
              title: "Action",
              width: 150,
              align: "center",
              render: this._renderActionCell,
            },
          ];

    return (
      <div className={styles.row_margin_top}>
        <Card title="Group members" extra={inviteBtn}>
          <Table
            dataSource={members}
            columns={columns}
            size="middle"
            pagination={{ pageSize: 100 }}
          />
        </Card>
      </div>
    );
  };

  _renderActionCell = (text: any, member: GroupMemberType) => {
    const {
      group_id,
      membership: { valid_days },
    } = member;

    if (group_id === CONST.B2C_GROUP_ID) {
      return null;
    }

    let items: Array<{ label: string; disabled: boolean }> = [];
    if (group_id === CONST.B2C_GROUP_ID) {
      items = [
        { label: "Send invite email", disabled: true },
        { label: "Deactivate", disabled: true },
        { label: "Delete", disabled: true },
        { label: "Reactivate", disabled: true },
      ];
    } else if (member.status === "Inactivated") {
      items = [
        { label: "Send invite email", disabled: false },
        { label: "Deactivate", disabled: false },
        { label: "Delete", disabled: false },
        { label: "Reactivate", disabled: true },
      ];
    } else if (valid_days > 0) {
      // Trial
      items = [
        { label: "Send invite email", disabled: true },
        { label: "Deactivate", disabled: false },
        { label: "Delete", disabled: false },
        { label: "Reactivate", disabled: true },
      ];
    } else if (valid_days === -1) {
      // Active
      items = [
        { label: "Send invite email", disabled: true },
        { label: "Deactivate", disabled: false },
        { label: "Delete", disabled: false },
        { label: "Reactivate", disabled: true },
      ];
    } else if (valid_days === 0) {
      // Deactivated
      items = [
        { label: "Send invite email", disabled: true },
        { label: "Deactivate", disabled: true },
        { label: "Delete", disabled: false },
        { label: "Reactivate", disabled: false },
      ];
    }

    const buttons = (
      <Menu onClick={(param) => this._onClickActionButton(param.key, member)}>
        {items.map((item) => (
          <Menu.Item key={item.label} disabled={item.disabled}>
            {item.label}
          </Menu.Item>
        ))}
      </Menu>
    );

    const validButton = items.find((item) => !item.disabled) as any;
    return (
      <Dropdown overlay={buttons}>
        <Button>
          {validButton.label} <Icon type="down" />
        </Button>
      </Dropdown>
    );
  };

  _fetchGroupData = async () => {
    try {
      const res = await QUERY<GroupDetailType>(GET_GROUP_DETAIL, {
        groupIds: [this.groupId],
      });
      res.groupMembers.forEach((e, i) => {
        e.key = i + 1;
        e.created_at = dayjs(e.created_at).format("DD.MM.YYYY");
        e.active_in_30_days = res.statistics.active_30_days_user_emails.includes(e.email);
      });

      this.groupDetailData = res;
    } catch (e) {
      Modal.error({
        title: "Oops, something goes wrong.",
        content: e.message,
        okText: "GOT IT",
      });
    }
  };

  _goToInviteMemberPage = () => {
    this.props.history.push(`/admin/group-invite?id=${this.groupId}&name=${this.groupName}`);
  };

  _onClickActionButton = (
    key: "Send invite email" | "Deactivate" | "Delete" | "Reactivate" | string,
    member: GroupMemberType,
  ) => {
    switch (key) {
      case "Send invite email":
        this._reInviteMember(member);
        break;
      case "Deactivate":
        this._deactivateMember(member);
        break;
      case "Delete":
        this._deleteMember(member);
        break;
      case "Reactivate":
        this._reactivate(member);
        break;
    }
  };

  _reInviteMember = (member: GroupMemberType) => {
    Modal.confirm({
      title: "Do you want to send another email invitation?",
      content: (
        <div>
          Yomento sends 3 automatic re-invitational emails if the member has not yet activated their
          account. We do this:
          <div style={{ marginTop: 10 }}>
            • One day after first invitation
            <br />• Two day after first invitation
            <br />• 7 day after first invitation
          </div>
        </div>
      ),
      okText: "Re-Invite",
      width: CONST.MODAL_CONFIRM_WIDTH,
      onOk: async () => {
        try {
          await QUERY(RE_INVITE_MEMBER, { email: member.email });
        } catch (e) {
          Modal.error({
            title: e.message,
          });
        }
      },
    });
  };

  _upgradeToProMember = (member: GroupMemberType) => {
    Modal.confirm({
      title: "Please confirm upgrade!",
      content: `By upgrading this member to Pro Membership, you accept that your organization will be charged according to the agreed price plan.`,
      okText: "Upgrade",
      width: CONST.MODAL_CONFIRM_WIDTH,
      onOk: async () => {
        try {
          const newMembership = Membership.types.find((e) => e.valid_days < 0);
          if (newMembership && this.groupDetailData) {
            const foundMember = this.groupDetailData.groupMembers.find(
              (e) => e.email === member.email,
            );
            if (foundMember) {
              const params = {
                membership_id: newMembership.id,
                email: member.email,
              };
              foundMember.membership = (
                await QUERY<{ member: GroupMemberType }>(UPDATE_MEMBER_SHIP, params)
              ).member.membership;
            }
          }
        } catch (e) {
          Modal.error({
            title: e.message,
          });
        }
      },
    });
  };

  _deactivateMember = (member: GroupMemberType) => {
    Modal.confirm({
      title: "Deactivate member",
      content: (
        <div>
          By ending this member’s Pro Membership, they will not be able to access any content in the
          Yomento app anymore.
          <div style={{ marginTop: 10 }}>We will notify the member through email about this.</div>
        </div>
      ),
      okText: "End Pro",
      okButtonProps: { type: "danger" },
      width: CONST.MODAL_CONFIRM_WIDTH,
      onOk: async () => {
        try {
          const newMembership = Membership.types.find((e) => e.valid_days === 0);
          if (newMembership && this.groupDetailData) {
            const foundMember = this.groupDetailData.groupMembers.find(
              (e) => e.email === member.email,
            );
            if (foundMember) {
              const params = {
                membership_id: newMembership.id,
                email: member.email,
              };

              await QUERY<{ member: GroupMemberType }>(UPDATE_MEMBER_SHIP, params);
              await this._fetchGroupData();
            }
          }
        } catch (e) {
          Modal.error({
            title: e.message,
          });
        }
      },
    });
  };

  _deleteMember = (member: GroupMemberType) => {
    Modal.confirm({
      title: "Delete member",
      content: (
        <div>
          By deleting this member, they will be removed from the group. If you only want to pause
          the account, use the deactivate option.
          <div style={{ marginTop: 10 }}>We will notify the member through email about this.</div>
        </div>
      ),
      okText: "Delete",
      okButtonProps: { type: "danger" },
      width: CONST.MODAL_CONFIRM_WIDTH,
      onOk: async () => {
        try {
          await MUTATE<string>(DELETE_MEMBER, {
            email: member.email,
          });
          if (this.groupDetailData) {
            this.groupDetailData.groupMembers = this.groupDetailData.groupMembers.filter(
              (e) => e.email !== member.email,
            );
          }
        } catch (e) {
          Modal.error({
            title: e.message,
          });
        }
      },
    });
  };

  _reactivate = (member: GroupMemberType) => {
    Modal.confirm({
      title: "Reactivate member",
      content:
        "By reactivating this member, you accept that your organization will be charged according to the agreed price plan.",
      okText: "Reactivate",
      width: CONST.MODAL_CONFIRM_WIDTH,
      onOk: async () => {
        try {
          const newMembership = Membership.types.find((e) => e.valid_days < 0);
          if (newMembership) {
            const params = {
              membership_id: newMembership.id,
              email: member.email,
            };
            await QUERY(UPDATE_MEMBER_SHIP, params);

            await this._fetchGroupData();
          }
        } catch (e) {
          Modal.error({
            title: e.message,
          });
        }
      },
    });
  };
}

const GET_GROUP_DETAIL = `
query($groupIds: [Int!]!) {
  groupMembers(keyword: null, size: 1000, offset: 0, groupIds: $groupIds) {
    name
    email
    created_at
    activate_at
    status
    membership {
      valid_days
      type
    }
    access_code
  }
  statistics(groupIds: $groupIds) {
    group_ids
    active_groups
    total_members
    total_active_members
    total_inactive_members
    active_30_days_users
    active_30_days_user_emails
    total_training_activities
    total_training_sessions
    total_weekly_reflections
				total_feed_forwards
				completed_feed_forwards
    weekly_avg
				feed_forward_last90days_total_records
	feed_forward_habit_index_avg
	feed_forward_trust_nps
    practiced_areas
    practiced_loops {
      loop_id
      loop_title
      loop_count
      area_id
      area_name
    }
    journey_sessions {
      count
      no_of_session
    }
    feed_forward_top_requested {
      loop_id
      loop_title
    }
    feed_forward_top_satisfied {
      loop_id
      loop_title
    }
    weekly_trend {
      year
      week
      training_sessions
      active_users
    }
    effect_survey {
      type
      no_of_yes
      no_of_no
    }
    feed_forward_quarterly_stats {
      year
      quarter
      total_lhp_records
      trust_nps_avg
      habit_index_avg
    }
  }
}`;

interface GroupDetailType {
  groupMembers: Array<GroupMemberType>;
  statistics: StatisticsType;
}
